import { t } from '../../services/i18n';

export class RcAuthStatusView extends HTMLElement {
  isAuthenticated = false;
  userName = '';
  showDashboardLink = false;

  render(): void {
    if (!this.isAuthenticated) {
      this.innerHTML = `<a href="/login/" class="btn btn-outline">${t('auth.login')}</a><a href="/pricing/" class="btn btn-primary">${t('auth.startFree')}</a>`;
      return;
    }
    this.innerHTML = `${this.showDashboardLink ? `<a href="/dashboard/" class="btn btn-outline">${t('auth.dashboard')}</a>` : ''}<a href="/profile/" class="user-name">${this.escape(this.userName)}</a><button class="btn-logout">${t('auth.logout')}</button>`;
    this.querySelector('.btn-logout')?.addEventListener('click', () => this.dispatchEvent(new CustomEvent('auth-status-logout', { bubbles: true })));
  }

  private escape(str: string): string {
    const el = document.createElement('span');
    el.textContent = str;
    return el.innerHTML;
  }
}

if (!customElements.get('rc-auth-status-view')) {
  customElements.define('rc-auth-status-view', RcAuthStatusView);
}
